import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { Spin, Select } from "antd";
import DynamicPieChart from "../../pieChart";
import DynamicColumnChart from "../../columnChart";
import DynamicBarChart from "../../barChart";
import DynamicLineChart from "../../lineChart";

const { Option } = Select;

const TotalFarmSizeProcurement = ({ isMaximized, openMaximize }) => {
  const [loading, setLoading] = useState(true);
  const [totalSize, setTotalSize] = useState(0);

  const [stateData, setStateData] = useState([]);
  const [cropData, setCropData] = useState([]);

  const [selectedState, setSelectedState] = useState("all");
  const [selectedCrop, setSelectedCrop] = useState("all");

  const [chartType, setChartType] = useState("pie");
  const [viewType, setViewType] = useState("state");

  const { sendRequest: getData } = useHttp();

  useEffect(() => {
    const url = `/api/totalFarmSizeProcurement/?userId=${localStorage.getItem(
      "id"
    )}`;

    getData({ url }, (res) => {
      setTotalSize(res.totalFarmSize || 0);
      setStateData(res.farmSizePerState || []); 
      setCropData(res.farmSizePerCrop || []);
      setLoading(false);
    });
  }, [getData]);

  let chartDataset = [];

  if (viewType === "state") {
    chartDataset =
      selectedState === "all"
        ? stateData
        : stateData.filter((s) => s.state === selectedState);
  } else {
    chartDataset =
      selectedCrop === "all"
        ? cropData
        : cropData.filter((c) => c.cropName === selectedCrop);
  }

  if (isMaximized) {
    return (
      <div style={{ width: "100%", height: "100%", padding: "10px" }}>
        <div className="flex justify-between items-center mb-4">
          <Select
            value={viewType}
            style={{ width: 180 }}
            onChange={(v) => {
              setViewType(v);
              setSelectedState("all");
              setSelectedCrop("all");
            }}
          >
            <Option value="state">State Wise</Option>
            <Option value="crop">Crop Wise</Option>
          </Select>

          {viewType === "state" && (
            <Select
              value={selectedState}
              style={{ width: 200 }}
              onChange={(v) => setSelectedState(v)}
            >
              <Option value="all">All States</Option>
              {stateData.map((s, i) => (
                <Option key={i} value={s.state}>
                  {s.state || "Unknown"}
                </Option>
              ))}
            </Select>
          )}

          {viewType === "crop" && (
            <Select
              value={selectedCrop}
              style={{ width: 200 }}
              onChange={(v) => setSelectedCrop(v)}
            >
              <Option value="all">All Crops</Option>
              {cropData.map((c, i) => (
                <Option key={i} value={c.cropName}>
                  {c.cropName}
                </Option>
              ))}
            </Select>
          )}

          <Select
            value={chartType}
            style={{ width: 150 }}
            onChange={(v) => setChartType(v)}
          >
            <Option value="pie">Pie Chart</Option>
            <Option value="column">Column Chart</Option>
            <Option value="bar">Bar Chart</Option>
            <Option value="line">Line Chart</Option>
          </Select>
        </div>

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h1 style={{ fontSize: "38px", fontWeight: "700", color: "#2d4f1d" }}>
            {totalSize} Ha
          </h1>
          <p style={{ fontSize: "18px", color: "#2d4f1d" }}>Total Farm Size</p>
        </div>

        {chartType === "pie" && (
          <DynamicPieChart
            data={chartDataset}
            angleField="totalArea"
            colorField={viewType === "state" ? "state" : "cropName"}
            isMaximized={true}
          />
        )}

        {chartType === "column" && (
          <DynamicColumnChart
            data={chartDataset}
            xField={viewType === "state" ? "state" : "cropName"}
            yField="totalArea"
            seriesField={viewType === "state" ? "state" : "cropName"}
            xAxisTitle={viewType === "state" ? "State" : "Crop"}
            yAxisTitle="Area (Ha)"
          />
        )}

        {chartType === "bar" && (
          <DynamicBarChart
            data={chartDataset}
            xField={viewType === "state" ? "state" : "cropName"}
            yField="totalArea"
            seriesField={viewType === "state" ? "state" : "cropName"}
          />
        )}

        {chartType === "line" && (
          <DynamicLineChart
            data={chartDataset}
            xField={viewType === "state" ? "state" : "cropName"}
            yField="totalArea"
            seriesField={viewType === "state" ? "state" : "cropName"}
          />
        )}
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl shadow-md"
      style={{
        background: "#f3e8d3",
        height: "200px",
        width: "100%",
        padding: "18px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <Spin />
        </div>
      ) : (
        <>
          <div style={{ marginTop: "0px", textAlign: "center" }}>
            <h1 style={{ fontSize: "40px", fontWeight: "700", color: "#3d5c26" }}>
              {totalSize} Ha
            </h1>
            <p style={{ marginTop: "-6px", fontSize: "17px", color: "#3d5c26" }}>
              Farm Size
            </p>
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "8px",
              right: "18px",
              cursor: "pointer",
              fontWeight: "600",
              color: "#3d5c26",
              fontSize: "14px",
            }}
            onClick={openMaximize}
          >
            More...
          </div>
        </>
      )}
    </div>
  );
};

export default TotalFarmSizeProcurement;
